import Grid from "@mui/material/Grid";
import React from "react";
import Typography from "@mui/material/Typography";

const HelpModuleMailFaxHeader = props => {
	return (
		<Typography variant="h1">
			Mail or Fax
		</Typography>
	);
};

const HelpModuleMailFax = props => {
	return (
		<React.Fragment>
			<Grid container spacing={{ xs: 0, lg: 2 }}>
				<Grid item xs={12} md={6}>
					<Typography>
						PHEAA Default Collections<br />
						P.O. Box 8147<br />
						Harrisburg, PA 17105-8147
					</Typography>
					<Typography component="h2" sx={{ mt: 6 }} variant="h5">
						For express or overnight deliveries:
					</Typography>
					<Typography sx={{ mt: 1 }}>
						PHEAA Default Collections<br />
						1200 North 7th Street<br />
						Harrisburg, PA 17102
					</Typography>
					<Typography component="h2" sx={{ mt: 6 }} variant="h5">
						For payments (except payoffs):
					</Typography>
					<Typography sx={{ mt: 1 }}>
						PHEAA<br />
						P.O. Box 1375<br />
						Buffalo, NY 14240-1375
					</Typography>
					<Typography component="h2" sx={{ mt: 6 }} variant="h5">
						For payoffs (payments in full):
					</Typography>
					<Typography sx={{ mt: 1 }}>
						PHEAA Default Collections<br />
						P.O. Box 8147<br />
						Harrisburg, PA 17105-8147
					</Typography>
				</Grid>
				<Grid item xs={12} md={6}>
					<Typography component="h2" mt={{ xs: 6, md: 0 }} variant="h5">
						Fax #
					</Typography>
					<Typography component="p" variant="h2" sx={{ mb: 1, mt: 2 }}>
						717-720-3644
					</Typography>
					<Typography>
						When returning documentation via fax, please make sure you include either your SSN or account number so we can process your request as efficiently as possible.
					</Typography>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default HelpModuleMailFax;
export { HelpModuleMailFaxHeader };